import Vue from 'vue'
import { createImage} from '~image'
import NuxtImg from '~image/components/nuxt-img.vue'
import NuxtPicture from '~image/components/nuxt-picture.vue'

import * as staticRuntime$1e03 from '/webapp/node_modules/@nuxt/image/dist/runtime/providers/static.js'
import * as storyblokRuntime$43e0 from '/webapp/node_modules/@nuxt/image/dist/runtime/providers/storyblok.js'
import * as ipxRuntime$ac6f from '/webapp/node_modules/@nuxt/image/dist/runtime/providers/ipx.js'

const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536,
    "3xl": 1920
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "a.storyblok.com",
    "storyblok.com"
  ],
  "alias": {}
}

imageOptions.providers = {
  ['static']: { provider: staticRuntime$1e03, defaults: {} },
  ['storyblok']: { provider: storyblokRuntime$43e0, defaults: {"baseURL":"https://a.storyblok.com","modifiers":{"format":"webp","fit":"in","quality":85}} },
  ['ipx']: { provider: ipxRuntime$ac6f, defaults: {} }
}

Vue.component(NuxtImg.name, NuxtImg)
Vue.component(NuxtPicture.name, NuxtPicture)
Vue.component('NImg', NuxtImg)
Vue.component('NPicture', NuxtPicture)

export default function (nuxtContext, inject) {
  const $img = createImage(imageOptions, nuxtContext)

  if (process.static && process.server) {
    nuxtContext.beforeNuxtRender(({ nuxtState }) => {
      const ssrData = nuxtState.data[0] || {}
      ssrData._img = nuxtState._img || {}
    })
  }

  inject('img', $img)
}
